import { useMutation } from 'react-query'
import {
    getData,
    postData
} from 'api/request'
import {
    getAccountUrl,
    getUserDetailUrl
} from 'api/api'
import dataStorage from 'dataStorage'

const submitAccount = async (data) => {
    const result = await postData(getAccountUrl(), data)
    return result
}

const useSubmitAccount = () => {
    return useMutation((variables) => submitAccount(variables))
}

const getAccountStatus = async (data) => {
    const userId = dataStorage.auth?.userId
    // const useDetail = await getData(getUserDetailUrl(userId))
    const accountOpening = await getData(getAccountUrl())
    return accountOpening
}

const useAccountStatus = () => {
    return useMutation((variables) => getAccountStatus(variables))
}

export {
    useSubmitAccount,
    useAccountStatus
}